<div class="alertbox waiting" style="padding: 24px">
    <div class="icon">
        <img src="assets/img/icon/waiting.png" alt="waiting" />
    </div>
    <h4>{{ 'Congrats' | translate }}</h4>
    <p style="white-space: pre-wrap;">
        {{ 'Transaction successfully created' | translate }}
    </p>
</div>
<div class="pButton">
    <button class="btn btn-primary" (click)="backToMerchant()">
        {{ 'Back to Merchant' | translate }}
    </button>
</div>